<nz-drawer
    [nzVisible]="visible"
    [nzWidth]="640"
    nzTitle="Workflow Run Details"
    (nzOnClose)="onClose()"
>
    <ng-container *nzDrawerContent>
        <div *ngIf="loading" class="workflow-run-detail-drawer__loading">
            <span nz-icon nzType="loading"></span> Loading…
        </div>
        <workflow-run-details
            *ngIf="!loading && run"
            [run]="run"
            [inlineHeaderActions]="true"
            [showRerun]="!run.reranAt"
            [rerunLoading]="rerunning"
            [showRawJson]="false"
            (rerun)="onRerun()"
        ></workflow-run-details>
    </ng-container>
</nz-drawer>
